<!--
 * @Author: wzc
 * @Date: 2021-01-26 10:51:49
 * @LastEditors: wzc
 * @LastEditTime: 2021-06-18 10:41:24
 * 暂无数据 组价
-->
<template>
  <div
    class="NO_DATA"
    :class="className"
    :style="{
      zIndex: zIndex,
    }"
  >
    <div class="nodata_logo"></div>
    <span class="nodata_info mixtmt_font_12px" v-text="text"></span>
  </div>
</template>

<script>
export default {
  name: 'NODATA',
  props: {
    zIndex: {
      type: Number,
      default: 3,
    },
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      text: '暂无数据',
    }
  },
}
</script>

<style lang="scss" scoped>
.NO_DATA {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  &.relativePt50 {
    position: relative;
    padding-top: 6.94vw;
  }
  &.relativePt60 {
    position: relative;
    padding-top: 8.33vw;
  }
  &.relativePt120 {
    position: relative;
    padding-top: 16.66vw;
  }
  &.relativePtb30 {
    position: relative;
    padding: 4.16vw 0;
  }
  &.relativePtb60 {
    position: relative;
    padding: 8.33vw 0;
  }
  .nodata_logo {
    width: 17.36vw;
    height: 9.72vw;
    background-repeat: no-repeat;
    background-position: center;
    background-image: var(--mixtmt_notData_icon);
    background-size: auto 100%;
    object-fit: contain;
  }
  .nodata_info {
    padding-top: 2.083vw;
    color: rgba(60, 60, 60, 0.45);
  }
}
</style>
